import { updateLessonItem } from 'core/crud/contents.crud';
import { useTranslate } from 'core/hooks/useTranslate';
import { successResponse } from 'core/utils/utils';
import { useState } from 'react';
import { useToasts } from 'react-toast-notifications';

export function useAvatarsList({ showDropdown, onClick, onSaveAssignedStudents, allStudents, ariaLabel, lessonItemGuid, courseGuid, avatars }) {
  const { addToast } = useToasts();
  const { t } = useTranslate();
  const [openDropdown, setOpenDropdown] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openAssignStudentsDialog, setOpenAssignStudentsDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleShowDropdown(e) {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setOpenDropdown(true);
  }

  function handleCloseDropdown() {
    setOpenDropdown(false);
  }

  function handleClickComponent(e) {
    if (onClick) {
      onClick();
    } else if (showDropdown) {
      handleShowDropdown(e);
    } else if (onSaveAssignedStudents && allStudents) {
      setOpenAssignStudentsDialog(true);
    }
  }

  function handleCloseAssignStudentsDialog() {
    setOpenAssignStudentsDialog(false);
  }

  async function handleSaveAssignedStudents(students) {
    setLoading(true);
    try {
      const selectedStudents = students.filter((student) => student.selected);
      const newStudents = selectedStudents.map((student) => student.person_guid);
      const itemFor = selectedStudents.length === allStudents.length ? 'all' : 'some-users';
      const payload = {
        guid: lessonItemGuid,
        course_guid: courseGuid,
        item_for: itemFor,
        item_for_users: newStudents,
      };
      const response = await updateLessonItem(payload);
      if (successResponse(response)) {
        onSaveAssignedStudents({ assignedTo: selectedStudents, item_for: itemFor, item_for_users: newStudents, assignedUsers: selectedStudents });
      } else {
        addToast(t('lesson:Could not update resource'), {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }

    handleCloseAssignStudentsDialog();
  }

  function getMainAriaLabel() {
    if (ariaLabel) return ariaLabel;
    return t('common:X assigned students', { count: avatars.length }) + ': ' + avatars.map((avatar) => avatar.name).join(', ');
  }

  return {
    anchorEl,
    handleClickComponent,
    handleCloseAssignStudentsDialog,
    handleCloseDropdown,
    handleSaveAssignedStudents,
    getMainAriaLabel,
    loading,
    openAssignStudentsDialog,
    openDropdown,
  };
}
